import { render, staticRenderFns } from "./BlocoEvolucaoMonitoramentoAgricola.vue?vue&type=template&id=c9980054&scoped=true&lang=pug"
import script from "./BlocoEvolucaoMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoEvolucaoMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoEvolucaoMonitoramentoAgricola.vue?vue&type=style&index=0&id=c9980054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9980054",
  null
  
)

export default component.exports